export default {
  hello: 'Default Page',
  name: 'name',
  email: 'email',
  submit: 'Save',
  /**
   * NMS
   */

  form: {
    name: 'Name',
    email: 'Email',
    consultation_type: 'Type of consultation',
    consultation_type_placeholder: 'Select a consultation type',
    consultation_type_error: 'Please select a consultation type',
    consultation_details: 'Consultation details',
  },
  plans: {
    free: 'FREE',
    demo: 'DEMO',
    readonly: 'CONSULTA',
    internal: 'TECHNICAL',
    emprendedor: 'EMPRENDEDOR',
    pyme: 'PYME',
    pro: 'PRO',
    plus: 'PLUS',
    enterprise: 'PREMIUM',
    corporativo: 'PREMIUM',
  },

  empty: {
    title: '¡Ups! It seems that we cannot find what you are looking for',
    description: 'No results found for <strong>"{{search}}"</strong>. Try another search.',
  },
  survey: {
    nms: {
      title: 'Rate your experience',
      subtitle:
        "We'd love to hear what you think. Rate how easy it was for you to use our support.",
    },
  },
  events: {
    pos: {
      advice: {
        title: 'Everything you need to know about the Electronic POS 📢',
        description:
          'During <strong>June and July</strong> every <strong>Tuesday from 10 to 11 am</strong> COL, starting from 06/19',
      },
      today: {
        title: 'Electronic POS: Everything you need to know! 🧑‍💻',
        description:
          'Learn all about the new billing system that replaces the traditional POS. Free training sessions <strong>every Tuesday</strong> in June and July from <strong>10:00 to 11:00 am.</strong> Join now!',
      },
      yesterday: {
        title: 'Electronic POS: Everything you need to know! 🧑‍💻',
        description:
          'Tomorrow you will learn all about the new billing system that replaces the traditional POS. Free training sessions <strong>every Tuesday</strong> in June and July from <strong>10:00 to 11:00 am.</strong> ',
      },
    },
  },
  buttons: {
    file: 'Seleccionar archivo',
  },
  tags: {
    identification: 'Identification: {{id}}',
    createIdentification: 'Configure ID',
  },
  tooltips: {
    identification:
      'Your ID will facilitate the recognition of your account when you call support.',
    createIdentification:
      'Your ID will facilitate the recognition of your account when you call support.',
  },

  new_support_model: {
    wizard_steps: {
      step1: 'Description of your concern',
      step2: 'Related help',
      step3: 'Contact options',
    },
    described_inquery: {
      title: 'Hi, {{name_user}}, how can we help you?',
      title_without_name: 'Hi, how can we help you?',
      subtitle: 'Please describe your concern in general terms and I will help you resolve it.',
      cta_btn: 'Continue to',
      notification_chat:
        '<strong>You have an open chat!</strong> Continue your conversation with support.',
    },
    relationated_helps: {
      title: 'Related help',
      subtitle:
        'Some people with a similar concern found a solution in one of the following articles:',
      tabs_label: {
        all: 'All',
        article: 'Articles',
        video: 'Videos',
        community: 'Community Forum',
      },
      support_card: {
        title: 'Still not resolved your issue?',
        description: 'Explore your support channels and contact our team.',
        cta_btn: 'View support options',
      },
    },
    contact_options: {
      title: 'Contact options',
      subtitle: 'These are the support options available for your plan',
      support_options: {
        chat: {
          title: 'Chat with an agent',
          description: 'Talk to one of our agents through our live chat.',
        },
        try_chat: {
          title: 'Chat with an agent',
          description: 'Chat live with our agents - try it free for 15 days!',
        },
        group_training: {
          title: 'Schedule a group training',
          description: 'Join a group session and expand your community knowledge.',
        },
        individual_advice: {
          title: 'Schedule a one-on-one consultation',
          description: 'Select the schedule that best fits your needs and availability.',
        },
        send_email: {
          title: 'Send an email',
          description: 'Our inbox is available 24 hours a day to answer your questions.',
          message_final: {
            title: 'Mail sent!',
            message: 'We will be in touch very soon.',
            advice: "If you can't find the email, please check your Promotions or Spam folder.",
          },
        },
        whatsapp: {
          title: 'Write to us via WhatsApp',
          description: 'Get personalized assistance via WhatsApp.',
          message_final: {
            title: 'Write to us via WhatsApp',
            message: 'Scan the QR code to contact us using the app on your mobile.',
            button: 'Write from Web WhatsApp',
          },
        },
        call_agent: {
          title: 'Call a support agent',
          description: 'Available Monday to Friday from 8:00 am to 5:30 pm',
          message_final: {
            title: 'Call {{phone}} to speak to a support agent.',
            message:
              'Available Monday through Friday from 8:00 am to 5:30 pm and Saturday from 9 am to 12 pm.',
            identificationAdvice:
              'Este ID facilita la identificación rápida de tu cuenta durante las llamadas de soporte.',
          },
        },
        comunity_forum: {
          title: 'Ask questions in the community forum',
          description: 'Ask questions and get answers from the Alegra user community.',
        },
      },
      banner_upsell: {
        title: 'Get personalized support',
        description: 'Upgrade your plan and get support with premium features',
        ctas_btn: {
          upgrade: 'Upgrade plan',
          contact: 'Talk to sales',
        },
        modals: {
          contact: {
            title: 'Call an Alegra agent',
            message_final: {
              title: 'Call to {{phone}} and contact to {{agent}}',
              message: 'Available Monday through Friday from 8:00 a.m. to 5:30 p.m.',
            },
          },
        },
      },
    },
  },
}
